webpackJsonp([16],{

/***/ 1276:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(491);


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

// eslint-disable-line no-restricted-imports

function LikeButton() {
    this.defaultAttrs({
        currentLikeCount: '[data-like-count]'
    });

    this.getLikeCount = function () {
        return parseInt(this.select('currentLikeCount').text(), 10);
    };

    this.setLikeCount = function (count) {
        this.select('currentLikeCount').text(count);
    };

    this.isDesignLiked = function () {
        return this.$node.attr('data-liked') === 'true';
    };

    this.setDesignLiked = function (isLiked) {
        this.$node.attr('data-liked', '' + isLiked);
    };

    this.setLikeStatusAndCount = function (isLiked, likeCount) {
        this.setDesignLiked(isLiked);
        this.setLikeCount(likeCount);
    };

    this.onDesignLikedSuccess = function (e, data) {
        this.setLikeStatusAndCount(true, data.likeCount);
    };

    this.onDesignUnlikedSuccess = function (e, data) {
        this.setLikeStatusAndCount(false, data.likeCount);
    };

    this.toggle = function (e) {
        e.preventDefault();
        if (this.isDesignLiked()) {
            this.setLikeStatusAndCount(false, this.getLikeCount() - 1);
            this.trigger(this.$node, 'uiDesignUnliked');
        } else {
            this.setLikeStatusAndCount(true, this.getLikeCount() + 1);
            this.trigger(this.$node, 'uiDesignLiked');
        }
    };

    this.after('initialize', function () {
        this.on(this.$node, 'dataDesignLikedSuccess', this.onDesignLikedSuccess);
        this.on(this.$node, 'dataDesignUnlikedSuccess', this.onDesignUnlikedSuccess);

        this.on('click', this.toggle);
    });
}

exports.default = (0, _flightjs.component)(LikeButton);

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

function LikeData() {
    this.defaultAttrs({
        likeUrl: null
    });

    this.likeDesign = function (e, data) {
        _jquery2.default.ajax({
            url: this.attr.likeUrl,
            data: data,
            type: 'POST',
            headers: { Accept: 'application/json' },
            success: function (successData) {
                this.$node.trigger('dataDesignLikedSuccess', successData);
            }.bind(this),
            error: function () {
                this.$node.trigger('dataDesignLikedError');
            }.bind(this)
        });
    };

    this.unlikeDesign = function (e, data) {
        _jquery2.default.ajax({
            url: this.attr.likeUrl,
            data: data,
            type: 'DELETE',
            headers: { Accept: 'application/json' },
            success: function (successData) {
                this.$node.trigger('dataDesignUnlikedSuccess', successData);
            }.bind(this),
            error: function () {
                this.$node.trigger('dataDesignUnlikedError');
            }.bind(this)
        });
    };

    this.after('initialize', function () {
        this.on(this.$node, 'uiDesignLiked', this.likeDesign);
        this.on(this.$node, 'uiDesignUnliked', this.unlikeDesign);
    });
} // eslint-disable-line no-restricted-imports
exports.default = (0, _flightjs.component)(LikeData);

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

// eslint-disable-line no-restricted-imports

function ToggleVisible() {
    this.defaultAttrs({
        buttonSelector: '[data-toggle-visible-button]',
        elementSelector: '[data-toggle-visible-element]',
        hideOnBodyClickAttribute: 'data-toggle-visible-hide-on-body-click'
    });

    this.toggleVisible = function () {
        var $element = this.select('elementSelector');
        if ($element.is('[data-active]')) {
            this.hideElement();
        } else {
            this.showElement();
        }
    };

    this.hideElement = function () {
        this.select('buttonSelector').removeAttr('data-active');
        this.select('elementSelector').removeAttr('data-active');
    };

    this.showElement = function () {
        this.select('buttonSelector').attr('data-active', '');
        this.select('elementSelector').attr('data-active', '');
    };

    this.bodyClick = function (e, data) {
        if (this.$node.attr('data-toggle-visible-hide-on-body-click') !== 'false') {
            if (!this.$node.is(data.target) && this.$node.has(data.target).length === 0) {
                this.hideElement();
            }
        }
    };

    this.after('initialize', function () {
        this.on('click', {
            buttonSelector: this.toggleVisible
        });

        this.on(document, 'uiHideToggleVisible', this.bodyClick);
    });
}

exports.default = (0, _flightjs.component)(ToggleVisible);

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

// eslint-disable-line no-restricted-imports

function DropdownRepositioner() {
    this.defaultAttrs({
        eventName: null,
        dropdowns: null
    });

    this.after('initialize', function () {
        this.on(document, this.attr.eventName, this.repositionDetachedDropdown);
    });

    this.repositionDetachedDropdown = function () {
        var dropdowns = this.attr.dropdowns;
        var clickTarget = this.$node[0];

        dropdowns.forEach(function (dropdown) {
            if (dropdown.$el[0].contains(clickTarget)) {
                dropdown.positionDropdown();
            }
        });
    };
}

exports.default = (0, _flightjs.component)(DropdownRepositioner);

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _doT = __webpack_require__(56);

var _doT2 = _interopRequireDefault(_doT);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

// eslint-disable-line no-restricted-imports
function HtmlUpdater() {
    this.defaultAttrs({
        eventName: null,
        templateSelector: null
    });

    this.after('initialize', function () {
        this.on(document, this.attr.eventName, this.updateHtml);
    });

    this.updateHtml = function () {
        var html = (0, _jquery2.default)(this.attr.templateSelector).html();
        var template = _doT2.default.template(html);
        this.$node.html(template);
    };
}

exports.default = (0, _flightjs.component)(HtmlUpdater);

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _flightjs2 = _interopRequireDefault(_flightjs);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _lodash = __webpack_require__(25);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports
function layoutButton() {
    var MAX_ZOOM = 3;
    var MIN_ZOOM = 1;

    this.imageLoadPromise = _jquery2.default.Deferred();

    this.attributes({
        image: '[data-entry-image]',
        expandButton: '[data-image-expand]'
    });

    this.getOriginalImageDimensions = function () {
        var image = this.select('image');
        return {
            width: parseInt(image[0].naturalWidth, 10),
            height: parseInt(image[0].naturalHeight, 10)
        };
    };

    this.canZoomOut = function () {
        var image = this.select('image');
        var zoom = this.getZoomLevel();
        var container = this.$node;

        var isImageLargerThanContainer = image.height() > container.height() || image.width() > container.width();

        return isImageLargerThanContainer && zoom > MIN_ZOOM;
    };

    this.canZoomIn = function () {
        var image = this.select('image');
        var zoom = this.getZoomLevel();
        var dimensions = this.getOriginalImageDimensions();

        var isImageSmallerThanOriginal = image.width() < dimensions.width || image.height() < dimensions.height;

        return isImageSmallerThanOriginal && zoom < MAX_ZOOM;
    };

    this.getZoomLevel = function () {
        return parseInt(this.$node.attr('data-zoom'), 10);
    };

    this.setZoomLevel = function (zoom) {
        this.$node.attr('data-zoom', zoom);
    };

    this.zoom = function (e, direction) {
        var zoom = this.getZoomLevel();

        if (this.canZoomIn() && direction > 0) {
            zoom += 1;
        }

        if (this.canZoomOut() && direction < 0) {
            zoom -= 1;
        }

        this.setZoomLevel(zoom);

        // Make sure we resize the image parent container
        // before recalculating if we can zoom in / zoom out.
        this.resizeImageParentContainer();
        this.trigger('uiImageZoomed', {
            canZoomOut: this.canZoomOut(),
            canZoomIn: this.canZoomIn(),
            zoom: zoom
        });
    };

    this.resizeImageParentContainer = function () {
        var image = this.select('image');
        var parent = image.parent();
        var expandBtn = this.select('expandButton');

        parent.css({
            height: '100%',
            width: '100%'
        });

        var newHeight = expandBtn.css('display') !== 'none' && image.width() < image.height() ? image.width() : image.height();
        // Force reflow
        parent.offsetHeight; // eslint-disable-line no-unused-expressions

        parent.css({
            height: newHeight,
            width: image.width()
        });

        if (expandBtn.css('display') !== 'none' && newHeight === image.height()) {
            expandBtn.css('display', 'none');
        }
    };

    this.resize = function () {
        var _this = this;

        this.imageLoadPromise.done(function () {
            _this.resizeImageParentContainer();
            _this.trigger('uiImageResized', {
                canZoomOut: _this.canZoomOut(),
                canZoomIn: _this.canZoomIn()
            });
        });
    };

    this.expand = function () {
        this.setZoomLevel(2);

        this.select('expandButton').css('display', 'none');
        this.resizeImageParentContainer();
        this.trigger('uiImageZoomed', {
            canZoomOut: this.canZoomOut(),
            canZoomIn: this.canZoomIn()
        });
    };

    this.updateExpandButton = function () {
        if (this.getZoomLevel() !== MAX_ZOOM) {
            this.select('expandButton').removeAttr('data-hidden');
        } else {
            this.select('expandButton').attr('data-hidden', true);
        }
    };

    this.setupPromise = function () {
        var $image = this.select('image');
        var promise = this.imageLoadPromise;

        // resolve promise on image load
        $image.load(function () {
            promise.resolve();
        });

        // if already loaded, resolve promise now
        $image.each(function (idx, image) {
            if (image.complete) {
                promise.resolve();
            }
        });
    };

    this.after('initialize', function () {
        this.on('click', {
            expandButton: this.expand
        });

        // Run after all other components are initialized
        window.setTimeout(this.setupPromise.bind(this), 0);

        this.on(document, 'uiImageZoomRequested', this.zoom);
        this.on('uiImageResized', this.updateExpandButton);

        this.resize();
        this.on(document, 'uiSidebarToggled', this.resize);
        this.on(document, 'uiImageModeChanged', this.resize);
        this.on(window, 'resize', (0, _lodash2.default)(this.resize.bind(this), 150));
    });
} // eslint-disable-line no-restricted-imports
exports.default = _flightjs2.default.component(layoutButton);

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _flightjs2 = _interopRequireDefault(_flightjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

function zoomButton() {
    var ZOOM_OUT = -1;
    var ZOOM_IN = 1;

    this.attributes({
        zoomInButton: '[data-image-zoom-in]',
        zoomOutButton: '[data-image-zoom-out]'
    });

    this.disableButton = function (button) {
        this.select(button).attr('data-disabled', true).prop('disabled', true);
    };

    this.enableButton = function (button) {
        this.select(button).removeAttr('data-disabled').removeAttr('disabled');
    };

    this.updateButtons = function (e, data) {
        if (!data.canZoomOut) {
            this.disableButton('zoomOutButton');
        } else {
            this.enableButton('zoomOutButton');
        }

        if (!data.canZoomIn) {
            this.disableButton('zoomInButton');
        } else {
            this.enableButton('zoomInButton');
        }
    };

    this.clickZoomInButton = function () {
        var button = this.select('zoomInButton');

        if (button.is(':disabled') || button.attr('data-disabled') === 'true') {
            return;
        }

        this.trigger(document, 'uiImageZoomRequested', [ZOOM_IN]);
    };

    this.clickZoomOutButton = function () {
        var button = this.select('zoomOutButton');

        if (button.is(':disabled') || button.attr('data-disabled') === 'true') {
            return;
        }

        this.trigger(document, 'uiImageZoomRequested', [ZOOM_OUT]);
    };

    this.saveZoom = function (e, data) {
        document.cookie = 'entry:zoom=' + data.zoom;
    };

    this.after('initialize', function () {
        this.on('click', {
            zoomInButton: this.clickZoomInButton,
            zoomOutButton: this.clickZoomOutButton
        });

        this.on(document, 'uiImageResized', this.updateButtons);
        this.on(document, 'uiImageZoomed', this.updateButtons);
        this.on(document, 'uiImageZoomed', this.saveZoom);
    });
}

exports.default = _flightjs2.default.component(zoomButton);

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

// eslint-disable-line no-restricted-imports

function ShowHidden() {
    this.defaultAttrs({
        'hidden-items': '[data-hidden]',
        button: '[data-show-hidden-button]'
    });

    this.after('initialize', function () {
        this.on('click', {
            button: this.showHiddenItems
        });
    });

    this.showHiddenItems = function () {
        this.select('hidden-items').removeAttr('data-hidden');
        this.select('button').remove();
    };
}

exports.default = (0, _flightjs.component)(ShowHidden);

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _detachedDropdown = __webpack_require__(148);

var _detachedDropdown2 = _interopRequireDefault(_detachedDropdown);

var _like = __webpack_require__(151);

var _like2 = _interopRequireDefault(_like);

var _like3 = __webpack_require__(150);

var _like4 = _interopRequireDefault(_like3);

var _addComment = __webpack_require__(492);

var _addComment2 = _interopRequireDefault(_addComment);

var _fullScreen = __webpack_require__(493);

var _fullScreen2 = _interopRequireDefault(_fullScreen);

var _fullscreenMode = __webpack_require__(494);

var _fullscreenMode2 = _interopRequireDefault(_fullscreenMode);

var _toggleVisible = __webpack_require__(160);

var _toggleVisible2 = _interopRequireDefault(_toggleVisible);

var _image = __webpack_require__(289);

var _image2 = _interopRequireDefault(_image);

var _zoomControls = __webpack_require__(290);

var _zoomControls2 = _interopRequireDefault(_zoomControls);

var _showHidden = __webpack_require__(291);

var _showHidden2 = _interopRequireDefault(_showHidden);

var _dropdownRepositioner = __webpack_require__(177);

var _dropdownRepositioner2 = _interopRequireDefault(_dropdownRepositioner);

var _htmlUpdater = __webpack_require__(178);

var _htmlUpdater2 = _interopRequireDefault(_htmlUpdater);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports
(0, _jquery2.default)(function () {
    var dropdowns = _detachedDropdown2.default.createAll('[data-detached-dropdown]');

    _like2.default.attachTo('[data-flight-like-button]', {
        likeUrl: (0, _jquery2.default)('[data-flight-like-button]').data('like-url')
    });
    _like4.default.attachTo('[data-flight-like-button]');

    (0, _jquery2.default)('[data-login-signup-like-button]').on('click', function () {
        (0, _jquery2.default)(document).trigger('uiLikeButtonClicked');
    });

    _addComment2.default.attachTo('[data-comment-new]');
    _fullScreen2.default.attachTo('[data-page-wrapper]');
    _fullscreenMode2.default.attachTo('[data-entry]');

    _image2.default.attachTo('[data-image-container]');
    _zoomControls2.default.attachTo('[data-image-zoom-controls]');

    _showHidden2.default.attachTo('[data-show-hidden]');

    _toggleVisible2.default.attachTo('[data-toggle-visible]', {
        hideOnBodyClick: true
    });

    (0, _jquery2.default)('.fullscreen__panel__body').on('uiScrollToTargetRequested', function (e) {
        (0, _jquery2.default)(this).animate({
            scrollTop: (0, _jquery2.default)(e.target).offset().top
        }, 0);
    });
    _htmlUpdater2.default.attachTo('[data-login-signup-container]', {
        eventName: 'uiLikeButtonClicked',
        templateSelector: "[data-update-html-template='login-or-signup']"
    });

    _dropdownRepositioner2.default.attachTo('[data-login-signup-like-button]', {
        eventName: 'uiLikeButtonClicked',
        dropdowns: dropdowns
    });

    (0, _jquery2.default)(document).trigger('uiNeedsContestsOpenForInvitation');
});

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

// eslint-disable-line no-restricted-imports

function AddComment() {
    this.defaultAttrs({
        addCommentSelector: '[data-comment-new-text]',
        commentActionsSelector: '[data-comment-new-actions]',
        commentCancelSelector: '[data-comment-new-cancel]'
    });

    this.activate = function () {
        this.select('addCommentSelector').attr('data-active', true);
        this.trigger('uiShowControls');
        this.trigger('uiScrollToTargetRequested');
    };

    this.deactivate = function () {
        this.select('addCommentSelector').removeAttr('data-active');
    };

    this.showControls = function () {
        this.select('commentActionsSelector').attr('data-active', true);
    };

    this.hideControls = function () {
        this.select('commentActionsSelector').removeAttr('data-active');
    };

    this.blurDeactivate = function () {
        if (this.select('addCommentSelector').val().length === 0) {
            this.trigger('uiDeactivateTextarea');
            this.trigger('uiHideControls');
        }
    };

    this.cancelComment = function () {
        this.trigger('uiDeactivateTextarea');
        this.trigger('uiHideControls');
        this.select('addCommentSelector').val(null);
    };

    this.after('initialize', function () {
        this.on('uiActivateTextarea', this.activate);
        this.on('uiDeactivateTextarea', this.deactivate);

        this.on('uiShowControls', this.showControls);
        this.on('uiHideControls', this.hideControls);

        this.on('click', {
            addCommentSelector: this.activate,
            commentCancelSelector: this.cancelComment
        });
        this.on('focusout', {
            addCommentSelector: this.blurDeactivate
        });
    });
}

exports.default = (0, _flightjs.component)(AddComment);

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

// eslint-disable-line no-restricted-imports

function FullScreen() {
    this.defaultAttrs({
        heroContainerSelector: '[data-hero]',
        currentHeroImageSelector: '[data-hero-current]',
        sidebarContainerSelector: '[data-sidebar]'
    });

    this.activate = function () {
        this.$node.attr('data-full-screen', true);
        this.select('currentHeroImageSelector').attr('data-active', true);
        this.select('heroContainerSelector').attr('data-active', true);
        this.select('sidebarContainerSelector').attr('data-inactive', true);
    };

    this.deactivate = function () {
        this.$node.removeAttr('data-full-screen');
        this.select('currentHeroImageSelector').removeAttr('data-active');
        this.select('heroContainerSelector').removeAttr('data-active');
        this.select('sidebarContainerSelector').removeAttr('data-inactive');
    };

    this.toggle = function () {
        if (this.$node.attr('data-full-screen')) {
            this.trigger('uiDeactivateFullscreen');
        } else {
            this.trigger('uiActivateFullscreen');
        }
    };

    this.after('initialize', function () {
        this.on('uiActivateFullscreen', this.activate);
        this.on('uiDeactivateFullscreen', this.deactivate);
        this.on('click', {
            currentHeroImageSelector: this.toggle
        });
    });
}

exports.default = (0, _flightjs.component)(FullScreen);

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(7);

var _flightjs2 = _interopRequireDefault(_flightjs);

var _lodash = __webpack_require__(25);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fullscreenButton() {
    this.defaultAttrs({
        button: '[data-fullscreen-button]',
        className: 'fullscreen-mode',
        noTransitionsClassName: 'notransition'
    });

    this.toggle = function () {
        this.$node.toggleClass(this.attr.className);
    };

    this.enableTransitions = function () {
        this.$node.removeClass(this.attr.noTransitionsClassName);
    };

    this.disableTransitions = function () {
        this.$node.addClass(this.attr.noTransitionsClassName);
    };

    this.after('initialize', function () {
        this.on('click', {
            button: this.toggle
        });

        this.on(window, 'resize', this.disableTransitions);
        this.on(window, 'resize', (0, _lodash2.default)(this.enableTransitions.bind(this), 150));
    });
} // eslint-disable-line no-restricted-imports
exports.default = _flightjs2.default.component(fullscreenButton);

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// doT.js
// 2011-2014, Laura Doktorova, https://github.com/olado/doT
// Licensed under the MIT license.

(function () {
	"use strict";

	var doT = {
		name: "doT",
		version: "1.1.1",
		templateSettings: {
			evaluate:    /\{\{([\s\S]+?(\}?)+)\}\}/g,
			interpolate: /\{\{=([\s\S]+?)\}\}/g,
			encode:      /\{\{!([\s\S]+?)\}\}/g,
			use:         /\{\{#([\s\S]+?)\}\}/g,
			useParams:   /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,
			define:      /\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
			defineParams:/^\s*([\w$]+):([\s\S]+)/,
			conditional: /\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
			iterate:     /\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,
			varname:	"it",
			strip:		true,
			append:		true,
			selfcontained: false,
			doNotSkipEncoded: false
		},
		template: undefined, //fn, compile template
		compile:  undefined, //fn, for express
		log: true
	}, _globals;

	doT.encodeHTMLSource = function(doNotSkipEncoded) {
		var encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
			matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
		return function(code) {
			return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
		};
	};

	_globals = (function(){ return this || (0,eval)("this"); }());

	/* istanbul ignore else */
	if (typeof module !== "undefined" && module.exports) {
		module.exports = doT;
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return doT;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		_globals.doT = doT;
	}

	var startend = {
		append: { start: "'+(",      end: ")+'",      startencode: "'+encodeHTML(" },
		split:  { start: "';out+=(", end: ");out+='", startencode: "';out+=encodeHTML(" }
	}, skip = /$^/;

	function resolveDefs(c, block, def) {
		return ((typeof block === "string") ? block : block.toString())
		.replace(c.define || skip, function(m, code, assign, value) {
			if (code.indexOf("def.") === 0) {
				code = code.substring(4);
			}
			if (!(code in def)) {
				if (assign === ":") {
					if (c.defineParams) value.replace(c.defineParams, function(m, param, v) {
						def[code] = {arg: param, text: v};
					});
					if (!(code in def)) def[code]= value;
				} else {
					new Function("def", "def['"+code+"']=" + value)(def);
				}
			}
			return "";
		})
		.replace(c.use || skip, function(m, code) {
			if (c.useParams) code = code.replace(c.useParams, function(m, s, d, param) {
				if (def[d] && def[d].arg && param) {
					var rw = (d+":"+param).replace(/'|\\/g, "_");
					def.__exp = def.__exp || {};
					def.__exp[rw] = def[d].text.replace(new RegExp("(^|[^\\w$])" + def[d].arg + "([^\\w$])", "g"), "$1" + param + "$2");
					return s + "def.__exp['"+rw+"']";
				}
			});
			var v = new Function("def", "return " + code)(def);
			return v ? resolveDefs(c, v, def) : v;
		});
	}

	function unescape(code) {
		return code.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ");
	}

	doT.template = function(tmpl, c, def) {
		c = c || doT.templateSettings;
		var cse = c.append ? startend.append : startend.split, needhtmlencode, sid = 0, indv,
			str  = (c.use || c.define) ? resolveDefs(c, tmpl, def || {}) : tmpl;

		str = ("var out='" + (c.strip ? str.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g," ")
					.replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g,""): str)
			.replace(/'|\\/g, "\\$&")
			.replace(c.interpolate || skip, function(m, code) {
				return cse.start + unescape(code) + cse.end;
			})
			.replace(c.encode || skip, function(m, code) {
				needhtmlencode = true;
				return cse.startencode + unescape(code) + cse.end;
			})
			.replace(c.conditional || skip, function(m, elsecase, code) {
				return elsecase ?
					(code ? "';}else if(" + unescape(code) + "){out+='" : "';}else{out+='") :
					(code ? "';if(" + unescape(code) + "){out+='" : "';}out+='");
			})
			.replace(c.iterate || skip, function(m, iterate, vname, iname) {
				if (!iterate) return "';} } out+='";
				sid+=1; indv=iname || "i"+sid; iterate=unescape(iterate);
				return "';var arr"+sid+"="+iterate+";if(arr"+sid+"){var "+vname+","+indv+"=-1,l"+sid+"=arr"+sid+".length-1;while("+indv+"<l"+sid+"){"
					+vname+"=arr"+sid+"["+indv+"+=1];out+='";
			})
			.replace(c.evaluate || skip, function(m, code) {
				return "';" + unescape(code) + "out+='";
			})
			+ "';return out;")
			.replace(/\n/g, "\\n").replace(/\t/g, '\\t').replace(/\r/g, "\\r")
			.replace(/(\s|;|\}|^|\{)out\+='';/g, '$1').replace(/\+''/g, "");
			//.replace(/(\s|;|\}|^|\{)out\+=''\+/g,'$1out+=');

		if (needhtmlencode) {
			if (!c.selfcontained && _globals && !_globals._encodeHTML) _globals._encodeHTML = doT.encodeHTMLSource(c.doNotSkipEncoded);
			str = "var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : ("
				+ doT.encodeHTMLSource.toString() + "(" + (c.doNotSkipEncoded || '') + "));"
				+ str;
		}
		try {
			return new Function(c.varname, str);
		} catch (e) {
			/* istanbul ignore else */
			if (typeof console !== "undefined") console.log("Could not create a template function: " + str);
			throw e;
		}
	};

	doT.compile = function(tmpl, def) {
		return doT.template(tmpl, null, def);
	};
}());


/***/ })

},[1276]);


// WEBPACK FOOTER //
// page/profiles-designs-629585e94e24569ab0e4.js